import { useQuery } from "@tanstack/react-query";
import { dashboardApi } from "../services/dashboardApi";

export const useDashboardOverview = () => useQuery({
  queryKey: ["dashboard", "overview"],
  queryFn: dashboardApi.getOverview,
  staleTime: 0,
  refetchOnMount: "always",
  refetchOnWindowFocus: "always",
});

export const useManagementDashboard = (companyId: string, enabled = false) => useQuery({
  queryKey: ["dashboard", "management", companyId],
  queryFn: () => dashboardApi.getManagement(companyId),
  enabled: enabled && !!companyId,
  staleTime: 0,
  refetchOnMount: "always",
  refetchOnWindowFocus: "always",
});

export const managementSectionOptions = (companyId: string, enabled: boolean) => ({
  enabled: enabled && !!companyId,
  refetchOnWindowFocus: false,
});

export const useManagementAccounting = (companyId: string, enabled = false) => useQuery({
  queryKey: ["dashboard", "management", "accounting-position", companyId],
  queryFn: () => dashboardApi.getAccountingPosition(companyId),
  staleTime: 0,
  ...managementSectionOptions(companyId, enabled),
});

export const useManagementProductSettlement = (companyId: string, enabled = false) => useQuery({
  queryKey: ["dashboard", "management", "product-settlement", companyId],
  queryFn: () => dashboardApi.getProductSettlement(companyId),
  staleTime: 0,
  ...managementSectionOptions(companyId, enabled),
});

export const useManagementInvoicedSummary = (companyId: string, enabled = false) => useQuery({
  queryKey: ["dashboard", "management", "invoiced-summary", companyId],
  queryFn: () => dashboardApi.getInvoicedSummary(companyId),
  staleTime: 30_000,
  ...managementSectionOptions(companyId, enabled),
});

export const useManagementInvoicedTrend = (companyId: string, enabled = false) => useQuery({
  queryKey: ["dashboard", "management", "invoiced-trend", companyId],
  queryFn: () => dashboardApi.getInvoicedTrend(companyId),
  staleTime: 5 * 60_000,
  ...managementSectionOptions(companyId, enabled),
});

export const useManagementActivities = (companyId: string, enabled = false) => useQuery({
  queryKey: ["dashboard", "management", "activities", companyId || "authorized-company"],
  queryFn: () => dashboardApi.getActivities(companyId || undefined),
  staleTime: 30_000,
  enabled,
  refetchOnWindowFocus: false,
});
